import { Component, createRef } from 'preact';
import { html } from '../../helpers/preact-html';

class DesktopNavigationSelector extends Component {
  constructor() {
    super();
    this.refWrapper = createRef();
    this.refSlider = createRef();

    this.onScroll = this.onScroll.bind(this);
    this.onClickItem = this.onClickItem.bind(this);
  }

  componentDidMount() {}

  componentWillUnmount() {}

  onScroll() {
    const currentItemId = this.embla.selectedScrollSnap();
    if (currentItemId !== this.props.currentItemId) {
      this.props.onItemIdChange &&
        this.props.onItemIdChange(this.props.navTree.items[currentItemId].id);
    }
  }

  onClickItem(slideId) {
    if (slideId !== this.props.currentItemId) {
      this.props.onItemIdChange &&
        this.props.onItemIdChange(
          this.props.navTree.items.find(({ id }) => id === slideId).id,
        );
    }
  }

  render({ navTree, currentItemId }) {
    const currentSlideIndex = navTree.items.findIndex(
      (menuItem) => menuItem.id === currentItemId,
    );
    if (this.embla && this.embla.selectedScrollSnap() !== currentSlideIndex) {
      this.embla.scrollTo(currentSlideIndex);
    }

    return html`
      <div class="navigation-selector" ref=${this.refWrapper}>
        <div class="navigation-selector-label label"
          >Sie befinden sich im Bereich für …</div
        >
        <div>
          ${navTree.items.map(({ id, label }) => {
            const itemClasses = ['navigation-selector-item'];
            if (id === currentItemId) itemClasses.push('is-current');
            return html`
              <button
                class="${itemClasses.join(' ')}"
                onClick=${() => this.onClickItem(id)}
                >${label}
              </button>
            `;
          })}
        </div>
      </div>
    `;
  }
}

export { DesktopNavigationSelector };
